// @flow
import React, { useRef } from 'react'
import { Line, Transformer } from 'react-konva'
import ErrorBoundary from './ErrorBoundary'

import { colors } from '../styles'
import { TARGET_CANVAS_WIDTH } from './Editor'

type Props = {
  attributes: Object,
  editable: boolean,
  isSelected: boolean,
  onSelect: Function,
  onChange: Function,
}

export const TEXT_PADDING = 0
const LINE_WIDTH = 5

export const Divider = ({ attributes, editable, isSelected, onSelect, onChange }: Props) => {
  // console.log('Divider', attributes, isSelected)
  const contentRef = useRef()
  const trRef = useRef()

  React.useEffect(() => {
    // console.log('updating sample', isSelected, trRef.current?.nodes)
    if (editable && isSelected && contentRef?.current) {
      // console.log('actually updating', contentRef, contentRef.current)
      // we need to attach transformer manually
      trRef.current.nodes([ contentRef.current ])
      trRef.current.getLayer().batchDraw()
    }
  }, [ editable, trRef, isSelected ])

  // const handleDividerTransformEnd = (e) => {
  //   if (!editable) { return }
  //   // console.log('handleDividerTransformEnd', e.evt.detail, e)
  //   // transformer is changing scale of the node
  //   // and NOT its width or height
  //   // but in the store we have only width and height
  //   // to match the data better we will reset scale on transform end
  //   const node = contentRef.current
  //   const scaleX = node.scaleX()
  //   const scaleY = node.scaleY()
  //
  //   // console.log('node', scaleX, scaleY, node.className, node)
  //   // we will reset it back
  //   node.scaleX(1)
  //   node.scaleY(1)
  //
  //   onChange({
  //     ...attributes,
  //     x: node.x(),
  //     y: node.y(),
  //     // set minimal value
  //     width: node.width() * scaleX,
  //     height: node.height() * scaleY
  //   })
  // }

  const commonAttrs = editable ? {
    strokeWidth: LINE_WIDTH,
    stroke: colors.midGray,

    // onClick: onSelect,
    // onTap: onSelect,
    draggable: editable,

    onMouseEnter: (e) => {
      // style stage container:
      const container = e.target.getStage().container()
      e.target.stroke(colors.darkOrange)
      container.style.cursor = 'ew-resize'
    },
    onMouseLeave: (e) => {
      const container = e.target.getStage().container()
      e.target.stroke(colors.midGray)
      container.style.cursor = 'default'
    },
    onDragEnd: (e) => {
      if (!editable) { return }
      // console.log('divider onDragEnd', e)
      onChange && onChange({
        ...attributes,
        x: e.target.x(),
        y: e.target.y(),
      })
    },
    // onTransformEnd: handleDividerTransformEnd,
    dragBoundFunc: (val) => {
      // console.log('divider dragBoundFunc', val)
      return { x: Math.max(0, Math.min(val.x, (TARGET_CANVAS_WIDTH - LINE_WIDTH))), y: attributes.y }
    },
    ...attributes
  } : {
    strokeWidth: 10,
    stroke: colors.midGray,
    draggable: editable,
    ...attributes
  }

  // console.log('divider attrs', commonAttrs)
  const anchors = [] // text?.label ? [ 'middle-left', 'middle-right' ] : [ 'top-left', 'top-right', 'bottom-left', 'bottom-right' ]

  return (
    <>
      <ErrorBoundary>
        <Line ref={contentRef} {...commonAttrs} />

        {editable && isSelected && (
          <Transformer
            ref={trRef}
            enabledAnchors={anchors}
            anchorStroke={colors.darkOrange}
            borderStroke={colors.darkOrange}
            anchorCornerRadius={25}
            rotateAnchorOffset={25}
            boundBoxFunc={(oldBox, newBox) => {
              // console.log('box change', oldBox, newBox)
              // limit resize
              if (newBox.width < 5 || newBox.height < 5) {
                return oldBox
              }
              return newBox
            }}
          />
        )}
      </ErrorBoundary>
    </>
  )
}

Divider.defaultProps = {
  editable: false,
}

// Divider.whyDidYouRender = true

export default Divider
